<template>
  <s-sidebar margin-top="var(--topbar-height)" :route="route">
    <template #items>
      <s-sidebar-item v-if="equipe"
        route="/"
        label="Home"
        icon="mdiHome"
      />

      <s-sidebar-item v-if="equipe"
        route="/aplicativos"
        label="Aplicativos"
        icon="mdiApps"
      />

      <template v-if="isAdmin">
        <s-sidebar-item-group label="Usuários" icon="mdiAccountMultipleOutline">
          <s-sidebar-sub-item
            route="/usuarios"
            label="Usuários"
          />
          <s-sidebar-sub-item
            route="/usuarios/tipos"
            label="Tipos"
          />
        </s-sidebar-item-group>
      </template>
      
      <template v-else>
        <s-sidebar-item v-if="equipe"
          route="/usuarios"
          label="Usuários"
          icon="mdiAccountMultipleOutline"
        />
      </template>

      <s-sidebar-item v-if="equipe"
        route="/escolas"
        label="Escolas"
        icon="mdiSchool"
      />

      <s-sidebar-item v-if="equipe"
        route="/turmas"
        label="Turmas"
        icon="mdiAccountGroup"
      />

      <s-sidebar-item v-if="equipe || isSuporte"
        route="/equipamentos"
        label="Equipamentos"
        icon="mdiTabletCellphone"
      />

      <s-sidebar-item v-if="equipe"
        route="/relatorios"
        label="Relatórios"
        icon="mdiChartBar"
      />

      <s-sidebar-item v-if="equipe"
        route="/planos"
        label="Planos de Aula"
        icon="mdiBookOpenVariant"
      />

      <s-sidebar-item v-if="!isSuporte"
        route="/agenda"
        label="Agenda"
        icon="mdiCalendarMonthOutline"
      />

      <s-sidebar-item v-if="equipe"
        route="/cursos"
        label="Cursos"
        icon="mdiPlayCircleOutline"
      />

      <s-sidebar-item v-if="isAdmin"
        route="/organizacao"
        label="Organização"
        icon="mdiDomain"
      />

      <s-sidebar-item v-if="equipe"
        route="/guias"
        label="Guias de Uso"
        icon="mdiBookOpenPageVariantOutline"
      />
    </template>

    <template #actions>
      <div class="version-container" v-tooltip="`Versão: ${version}`">
        {{ version }}
      </div>
    </template>
  </s-sidebar>
</template>

<script setup lang="ts">
import { SSidebar, SSidebarItem, SSidebarItemGroup, SSidebarSubItem } from '@sieg-ad/componentes-vue';
import { useAuthStore } from '~/stores/auth';

const authStore = useAuthStore();
const { isAdministrador: isAdmin, isSuporte } = storeToRefs(authStore);
const route = useRoute();

//? `equipe` é o menu de quem opera as escolas. Fora dele: o Aluno (só Agenda) e o Suporte
//? (só Equipamentos) — a mesma fronteira que o guard global aplica em ~/constants/roles.
const equipe = computed(() =>
  authStore.isAdministrador || authStore.isGestor || authStore.isDocente);
const version = ref<string>(useRuntimeConfig().public.APP_VERSION);
</script>

<style scoped>
.version-container {
  padding: 0.5rem;
  font-size: 0.8rem;
  color: var(--text-tertiary);
  width: 100%;
  text-align: center;
}
</style>
